import { MDSButton, MDSButtonSize, MDSButtonVariant } from "@/mds";
import { AgentRelatedTasksCard } from "@/pages/agent/components/agent-related-tasks-card";
import type { TaskRowViewModel } from "@/pages/agent/tasks/agent-tasks-page.utils";

export const AgentProjectTasksCard = ({
  taskRows,
  dataLoaded,
  onOpenActivities,
  onOpenAllTasks,
  onOpenNote,
  onOpenProject,
  onOpenTask,
  onToggleTaskComplete,
}: {
  taskRows: TaskRowViewModel[];
  dataLoaded: boolean;
  onOpenActivities: ({ taskId }: { taskId: string }) => void;
  onOpenAllTasks: () => void;
  onOpenNote: ({ noteId }: { noteId: string }) => void;
  onOpenProject: ({ projectId }: { projectId: string }) => void;
  onOpenTask: ({ taskId }: { taskId: string }) => void;
  onToggleTaskComplete: ({ taskId }: { taskId: string }) => void;
}) => (
  <AgentRelatedTasksCard
    dataLoaded={dataLoaded}
    emptyLabel="No tasks in this project yet."
    showProject={false}
    taskRows={taskRows}
    title="Tasks"
    trailing={
      <MDSButton
        size={MDSButtonSize.Small}
        variant={MDSButtonVariant.Transparent}
        onPress={onOpenAllTasks}
      >
        Filter tasks
      </MDSButton>
    }
    onOpenActivities={onOpenActivities}
    onOpenNote={onOpenNote}
    onOpenProject={onOpenProject}
    onOpenTask={onOpenTask}
    onToggleTaskComplete={onToggleTaskComplete}
  />
);
